import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";

/* ===== seed ===== */

function getDailySeed(){

const d = new Date();

return d.getFullYear()*10000 + (d.getMonth()+1)*100 + d.getDate();

}

/* ===== random ===== */

function mulberry32(a){

return function(){

var t = a += 0x6D2B79F5;

t = Math.imul(t ^ t >>> 15, t | 1);

t ^= t + Math.imul(t ^ t >>> 7, t | 61);

return ((t ^ t >>> 14) >>> 0) / 4294967296;

}

}

/* ===== sudoku generator ===== */

function generateSudoku(seed){

const rand = mulberry32(seed);

const base = 3;
const side = 9;

function pattern(r,c){
return (base*(r%base)+Math.floor(r/base)+c)%side;
}

function shuffle(arr){

const a = arr.slice();

for(let i=a.length-1;i>0;i--){

const j=Math.floor(rand()*(i+1));

[a[i],a[j]]=[a[j],a[i]];

}

return a;

}

const rBase=[0,1,2];

const rows = shuffle(rBase).flatMap(g=>shuffle(rBase).map(r=>g*base+r));
const cols = shuffle(rBase).flatMap(g=>shuffle(rBase).map(c=>g*base+c));
const nums = shuffle([1,2,3,4,5,6,7,8,9]);

const board = rows.map(r=>cols.map(c=>nums[pattern(r,c)]));

const solution = board.map(r=>r.slice());

const puzzle = board.map(r=>r.slice());

for(let i=0;i<45;i++){

const r=Math.floor(rand()*9);
const c=Math.floor(rand()*9);

puzzle[r][c]=0;

}

return {puzzle,solution};

}

/* ===== time format ===== */

function formatTime(t){

const m=Math.floor(t/60);
const s=t%60;

return `${m}:${s.toString().padStart(2,"0")}`;

}

/* ===== component ===== */

export default function SudokuChallenge(){

const seed=getDailySeed();

const {puzzle,solution}=generateSudoku(seed);

const [board,setBoard]=useState(puzzle);
const [selected,setSelected]=useState(null);
const [started,setStarted]=useState(false);
const [finished,setFinished]=useState(false);
const [time,setTime]=useState(0);
const [playerName,setPlayerName]=useState("");

/* ===== timer ===== */

useEffect(()=>{

let timer;

if(started && !finished){

timer=setInterval(()=>{

setTime(t=>t+1);

},1000);

}

return ()=>clearInterval(timer);

},[started,finished]);

/* ===== check win ===== */

function checkWin(board){

for(let r=0;r<9;r++){

for(let c=0;c<9;c++){

if(board[r][c]!==solution[r][c]){

return false;

}

}

}

return true;

}

/* ===== cell change ===== */

const handleChange=(r,c,val)=>{

if(!started) return;

if(puzzle[r][c]!==0) return;

const num=parseInt(val)||0;

const newBoard=board.map(row=>row.slice());

newBoard[r][c]=num;

setBoard(newBoard);

const cell=document.getElementById(`${r}-${c}`);

if(num!==0){

if(num===solution[r][c]){

cell.style.color="green";

}else{

cell.style.color="red";

}

}

if(checkWin(newBoard)){

setFinished(true);

setTimeout(()=>{

alert("?? Congratulations "+playerName+"!");

},200);

}

};

/* ===== share ===== */

const share=async()=>{

const card=document.getElementById("shareCard");

const canvas=await html2canvas(card);

const img=canvas.toDataURL("image/png");

const text=
`${playerName} solved today's Sudoku in ${formatTime(time)}!\nCan you beat me?\nhttps://puzzlify.net/sudoku-challenge`;

const whatsapp=`https://wa.me/?text=${encodeURIComponent(text)}`;

window.open(whatsapp,"_blank");

};

/* ===== facebook ===== */

const shareFacebook=()=>{

const url="https://puzzlify.net/sudoku-challenge";

window.open(
`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
"_blank"
);

};

/* ===== render ===== */

return(

<div style={styles.page}>

<h2>Daily Sudoku Challenge</h2>

<p>Time: {formatTime(time)}</p>

{!started &&(

<div style={{marginBottom:20}}>

<input
placeholder="Enter your name"
value={playerName}
onChange={(e)=>setPlayerName(e.target.value)}
style={styles.input}
/>

<button
onClick={()=>setStarted(true)}
style={styles.startBtn}
>
Start Challenge
</button>

</div>

)}

<div style={styles.board}>

{board.map((row,r)=>

row.map((cell,c)=>{

const highlight=
selected &&
(
selected.r===r ||
selected.c===c ||
(
Math.floor(selected.r/3)===Math.floor(r/3) &&
Math.floor(selected.c/3)===Math.floor(c/3)
)
);

return(

<input
id={`${r}-${c}`}
key={`${r}-${c}`}
value={cell===0?"":cell}
maxLength={1}
onClick={()=>setSelected({r,c})}
onChange={(e)=>handleChange(r,c,e.target.value)}
style={{
...styles.cell,

background:
puzzle[r][c]?"#eee":
highlight?"#eaf4ff":"white",

borderRight:
(c%3===2 && c!==8)?"3px solid black":"1px solid #bbb",

borderBottom:
(r%3===2 && r!==8)?"3px solid black":"1px solid #bbb"

}}
/>

)

})

)}

</div>

{finished &&(

<div>

<h3>?? Puzzle Solved!</h3>

<p>Your time: {formatTime(time)}</p>

<div id="shareCard" style={styles.card}>

<h2>?? Puzzlify Sudoku</h2>

<h3>{playerName}</h3>

<p>Solved in {formatTime(time)}</p>

<p>Can you beat my score?</p>

<p>puzzlify.net</p>

</div>

<button onClick={share} style={styles.shareBtn}>
Share WhatsApp
</button>

<button onClick={shareFacebook} style={styles.shareBtn}>
Share Facebook
</button>

</div>

)}

</div>

)

}

/* ===== styles ===== */

const styles={

page:{
textAlign:"center",
padding:20,
fontFamily:"Arial"
},

input:{
padding:10,
fontSize:16,
marginRight:10
},

startBtn:{
padding:"10px 20px",
fontSize:16,
background:"#0984e3",
color:"white",
border:"none",
borderRadius:6,
cursor:"pointer"
},

board:{
display:"grid",
gridTemplateColumns:"repeat(9,45px)",
gap:2,
justifyContent:"center",
marginTop:20
},

cell:{
width:45,
height:45,
fontSize:22,
textAlign:"center",
border:"1px solid #bbb"
},

card:{
width:320,
margin:"20px auto",
padding:20,
background:"#ffffff",
borderRadius:10,
boxShadow:"0 5px 20px rgba(0,0,0,0.2)"
},

shareBtn:{
padding:"10px 20px",
margin:5,
fontSize:16,
background:"#27ae60",
color:"white",
border:"none",
borderRadius:6,
cursor:"pointer"
}

};